import { format } from 'sql-formatter';

/**
 * Formats SQL code with PostgreSQL dialect and consistent styling
 * @param sql - The SQL string to format
 * @returns Formatted SQL string, or original SQL if formatting fails
 */
export const formatSql = (sql: string): string => {
  try {
    return format(sql, {
      language: 'postgresql',
      keywordCase: 'upper',
      dataTypeCase: 'lower',
      functionCase: 'lower',
      tabWidth: 2,
      linesBetweenQueries: 1,
    });
  } catch (e) {
    console.error('SQL formatting error:', e);
    return sql;
  }
};
